import { from } from "rxjs";
import { selectMissingRecipeCost } from "../../../selectors/selectRecipeInfo";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { IdMissingResourceTypes } from "../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../ongoing-purchase/actionOngoingPurchase";
export var pathCultivationNotEnoughResources = function (action, state$) {
    var state = state$.value;
    var missingResources = selectMissingRecipeCost(state, action.recipe.recipe.id, 1);
    return from([
        actionOngoingPurchaseStandardSelect([
            {
                missingResources: missingResources,
                missingType: IdMissingResourceTypes.Resources,
            },
        ]),
        actionModalOpen(IdModal.NotEnoughResource),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/paths/pathCultivationNotEnoughResources.ts
// module id = 2029
// module chunks = 3